import 'view/css/e-invoice-audit-view.css';

import moment from 'moment';
import React, { useEffect, useState } from 'react';

import API from 'service/api';
import Util from 'service/util';
import ModalScreen from 'component/ModalScreen';

import EInvoicingAuditFilter from 'component/e-invoice/EInvocingAuditFilter';
import EInvoicingAuditBatchTable from 'component/e-invoice/EInvoicingAuditBatchTable';
import EInvoicingAuditBatchCard from 'component/e-invoice/EInvoicingAuditBatchCard';

class EInvoiceBatchDTO
{
  constructor(origin)
  {
    Object.assign(this, origin);
  }
  get batch_name() {
    const date = Util.LongDate(this.sent_dtm);
    return `${date} | ${this.sent_by}`;
  }
}

const EInvoicingAuditView = (props) =>
{
  const [modal,      setModal     ] = useState(null);
  const [modalTitle, setModalTitle] = useState('');

  const [from_dtm,  setFromDate ] = useState(moment().startOf('day').toDate());
  const [to_dtm,    setToDate   ] = useState(moment().add(1, 'days').startOf('day').toDate());
  
  const [batches,   setBatches  ] = useState([]);
  const [staff,     setStaff    ] = useState([]);

  const [filter,    setFilter] = useState(
    { company: '', staff: '', cd_license: '', media_type: '' }
  );

  const [sel_batch, setSelectedBatch] = useState(null);

  useEffect(() => {

    if (!moment(from_dtm).isValid()) { return; }

    const dto = {
      from_dtm: Util.ShortDate(from_dtm),
      to_dtm: Util.ShortDate(to_dtm),
    };

    // start load data
    API.getEInvoicingAudit(dto).then(data => {
      let batches = data.map(d => new EInvoiceBatchDTO(d));
      let staff = [...new Set(batches.map(b => b.sent_by))];
      setBatches(batches);
      setStaff(staff);
    });

  }, [from_dtm, to_dtm]);


  const onQuery = (query) => {
    setFromDate(query.from_dtm);
    setToDate(query.to_dtm);
  }

  const filterBactch = (batches) => batches.filter(x => {
      if (filter.staff && filter.staff !== x.sent_by) return false;
      return true;
  });

  const filterRecords = (items) => items.filter(x => {
    if (filter.company && x.company !== filter.company) return false;
    if (filter.cd_license && !x.cd_license.match(filter.cd_license)) return false;
    if (filter.media_type && x.media_type !== filter.media_type) return false;
    return true;
  });

  return (<>
    <h1>紀錄 - 電子賬單及收據紀錄</h1>
    <div className="cheque-view">
      <div className="action-panel">
        <EInvoicingAuditFilter filter={filter}
          showFilters={!!sel_batch} staffList={staff}
          onFilter={setFilter} onQuery={onQuery} />
      </div>
      <div className="einvoicing-audit-view-body">
        { !sel_batch
          ? <EInvoicingAuditBatchTable items={filterBactch(batches)} onSelect={setSelectedBatch}/> 
          : <EInvoicingAuditBatchCard batch={sel_batch}
              filter={filterRecords}
              onClose={()=>setSelectedBatch(null)} />
        }
      </div>
    </div>
    <ModalScreen title={modalTitle} show={!!modal} onClose={e=>setModal(null)}>
      { modal }
    </ModalScreen>
  </>);
}

export default EInvoicingAuditView;
